// extracted by mini-css-extract-plugin
module.exports = {"moreItems":"az_kac"};